import { ContactUsWidgetTypeEnum, type ContactUs } from '@parkingbase/ecommerce-api-demo';

export interface EffectiveSupportWidget {
  type?: ContactUsWidgetTypeEnum;
  id?: string;
}

/**
 * The support widget actually loaded for the company: the ContactUs config when it names
 * both a widget type and id, otherwise FreshDesk on the env fallback key — matching the
 * legacy reservation-site AppHeader.
 *
 * ## Invariants:
 * - The script injector and the Help link's opener must both resolve through this, or
 *   Help calls the API of a widget that was never loaded and the click does nothing.
 */
export function resolveEffectiveSupportWidget(
  contactUs: ContactUs | null | undefined,
  fallbackFreshdeskKey: string | undefined
): EffectiveSupportWidget {
  if (contactUs?.widgetId && contactUs?.widgetType) {
    return { type: contactUs.widgetType, id: contactUs.widgetId };
  }
  if (fallbackFreshdeskKey) {
    return { type: ContactUsWidgetTypeEnum.FRESHDESK, id: fallbackFreshdeskKey };
  }
  return {};
}
